import { NotificationProviderProps } from "./types";

const NotificationProvider = ({ onPermission }: NotificationProviderProps) => {
	return null;
};

export default NotificationProvider;
